const counter = 71;
export const version = `1.19.${counter}`;

// SET HERE Business Specific Features, such as reservations module, coffee module, etc.
export const coffeeBusinesses = process.env.NODE_ENV === 'production' ? [7] : [0];

export const reservationsModule = process.env.NODE_ENV === 'production' ? [7, 1] : [0];

export const lockCombination =
  process.env.NODE_ENV === 'production' ? [1, 6, 7, 15, 16, 8, 29, 28, 35, 49, 50, 55, 56, 57, 58, 60] : [1];

export const blockPressotherapyBoots = process.env.NODE_ENV === 'production' ? [7, 55, 56, 57, 58, 59, 60] : [1];
export const blockPressotherapySleeve = process.env.NODE_ENV === 'production' ? [7, 55, 56, 57, 58, 59, 60] : [0];
export const blockPressotherapyBelt = process.env.NODE_ENV === 'production' ? [7, 55, 56, 57, 58, 59, 60] : [0];
export const blockVenomKnee = process.env.NODE_ENV === 'production' ? [7, 55, 56, 57, 58, 59, 60] : [0];
export const blockVenomBack = process.env.NODE_ENV === 'production' ? [7] : [1];
export const blockVenomShoulder = process.env.NODE_ENV === 'production' ? [7] : [0];
export const blockCriotherapy = process.env.NODE_ENV === 'production' ? [7, 55, 56, 57, 58, 59, 60] : [0];
export const blockRotaheat = process.env.NODE_ENV === 'production' ? [7] : [0];
